import type { IBaseNotary } from "../../BaseNotaryFactory";
import { ContentType } from "@Front/Api/BaseApiService";
import type { OfficeFolderAnchor } from "le-coffre-resources/dist/Notary";
import type { IGetAnchorsParams } from "../OfficeFolderAnchors";
import { buildEmptyPayload } from "@Front/Api/LeCoffreApi/helpers/businessRequestPayloadHelpers";

export function createGetMethod(baseNotary: IBaseNotary) {
	return async (q?: IGetAnchorsParams): Promise<OfficeFolderAnchor[]> => {
		const url = new URL(baseNotary.namespaceUrl.concat("/anchors"));
		if (q) {
			baseNotary.appendJsonSearchParams(url, { q });
		}
		try {
			return await baseNotary.getRequest<OfficeFolderAnchor[]>(url);
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createGetByUidMethod(baseNotary: IBaseNotary, foldersUrl: string) {
	return async (folderUid: string): Promise<OfficeFolderAnchor> => {
		const url = new URL(foldersUrl.concat(`/${folderUid}/anchor`));
		try {
			return await baseNotary.getRequest<OfficeFolderAnchor>(url);
		} catch (err) {
			const httpStatus = (err as { http_status?: number })?.http_status;
			if (httpStatus === 404) {
				return Promise.reject(err);
			}
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createPostMethod(baseNotary: IBaseNotary, foldersUrl: string) {
	return async (folderUid: string): Promise<OfficeFolderAnchor> => {
		const url = new URL(foldersUrl.concat(`/${folderUid}/anchor`));
		try {
			return await baseNotary.postRequest<OfficeFolderAnchor>(url, buildEmptyPayload());
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createDownloadMethod(baseNotary: IBaseNotary, foldersUrl: string) {
	return async (folderUid: string): Promise<Blob> => {
		const url = new URL(foldersUrl.concat(`/${folderUid}/anchor/proof`));
		try {
			return await baseNotary.getRequest<Blob>(url, { contentType: ContentType.PDF, fileName: `certificat-${folderUid}.pdf` });
		} catch (err) {
			baseNotary.onError(err);
			return Promise.reject(err);
		}
	};
}
